var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNetpardyCap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 545,
    height: 368,
    viewBox: "0 0 545 368",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 328.5L25 344.608H521L504.565 328.174L9 328.5Z",
    fill: "#3600D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M521 344.608V19.4348L504.565 3V328.174L521 344.608Z",
    fill: "#9069FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M504.565 3H8V328.174H504.565V3Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M504.565 3H8V328.174M504.565 3V328.174H8M504.565 3L521 19.4348V344.608H24.4348L8 328.174",
    stroke: "#9069FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 368V345H521.426V0H544.5V368H0Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M239 56V223.476H261V56H239Z",
    fill: "#9069FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M239 242.575H261V258H239V242.575Z",
    fill: "#9069FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M239 56V223.476H261V56H239Z",
    stroke: "#9069FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M239 242.575H261V258H239V242.575Z",
    stroke: "#9069FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetpardyCap);
export default __webpack_public_path__ + "static/media/netpardy-cap.3076d9ef7667aad141fa718239576fb5.svg";
export { ForwardRef as ReactComponent };